import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import {
    IChecklist2ReportAnswer,
    IChecklist2ReportChecklistSummary,
    IChecklistReportDetailsData,
} from '../../shared/fi-checklist2-report';
import { FiReportWidgetDetailsBaseDirective } from '@fi-shared/checklist/fi-checklist2-report/shared/report-widget-details-base.directive';
import { FiChecklist2ReportType } from '@fi-shared/checklist/fi-checklist2-report/enums/fi-checklist2-report-type';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';

@Component({
    selector: 'fi-open-checklists-report',
    templateUrl: './open-checklists-report.component.html',
    styleUrls: ['./open-checklists-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-open-checklists-report' },
    standalone: false,
})
export class FiOpenChecklistsReportComponent extends FiReportWidgetDetailsBaseDirective {
    @Output() onOpenChecklistReportDetails = new EventEmitter<IChecklistReportDetailsData>();

    filteredNotOkAnswerDetails: IChecklist2ReportAnswer[] = [];
    filteredChecklists: IChecklist2ReportChecklistSummary[] = [];

    setFilteredChecklists(newFilteredChecklists: IChecklist2ReportChecklistSummary[]) {
        this.filteredChecklists = [...newFilteredChecklists];
    }

    setFilteredNotOkAnswerDetails(newFilteredNotOkAnswerDetails: IChecklist2ReportAnswer[]) {
        this.filteredNotOkAnswerDetails = [...newFilteredNotOkAnswerDetails];
    }

    openChecklistReportDetails(checklistReportDetailsData: IChecklistReportDetailsData) {
        this.onOpenChecklistReportDetails.emit(checklistReportDetailsData);
    }

    protected readonly FiChecklist2ReportType = FiChecklist2ReportType;
    protected readonly FiInfoIconMode = FiInfoIconMode;
}
